import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Szmf033aRequest, Szmf033aResponse, Szmf033aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSzmf033aService {

  /**
   * コンストラクタ
   * @param {Szmf033aService} szmf033aService
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSzmf033aService
   */
  constructor(
    private szmf033aService: Szmf033aService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 返金結果登録API呼び出し
   *
   * @param {*} request
   * @return {*}  {Observable<Szmf033aResponse>}
   * @memberof UsedSzmf033aService
   */
  public doSzmf033a(request: Szmf033aRequest): Observable<Szmf033aResponse> {

    // 年月日項目のフォーマット
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

    return this.szmf033aService.ke10WSZMF033APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZMF033A');
          return throwError(err.message);
        })
      );
  }
}